import { Bounds } from "../geometry.bounds";
import { Cartesian3 } from "../geometry.cartesian";
import { AbstractShape } from "./geometry.shape";
import { ShapeType } from "./geometry.shapes.interfaces";
export class Circle extends AbstractShape {
    constructor(c, radius) {
        super(ShapeType.Circle);
        this._center = c;
        this._radius = radius;
    }
    get center() {
        return this._center;
    }
    set center(v) {
        if (Cartesian3.Equals(v, this._center) == false) {
            this._center = v;
            this.invalidateBounds();
        }
    }
    get radius() {
        return this._radius;
    }
    set radius(v) {
        if (this._radius !== v) {
            this._radius = v;
            this.invalidateBounds();
        }
    }
    _buildBounds() {
        const r = this._radius;
        const x = this._center.x;
        const y = this._center.y;
        return new Bounds(x - r, y - r, r * 2, r * 2);
    }
    _getPoints() {
        return [this._center];
    }
}
//# sourceMappingURL=geometry.circle.js.map